import { render, staticRenderFns } from "./vipPublisher.vue?vue&type=template&id=25a9d303"
import script from "./vipPublisher.vue?vue&type=script&lang=js"
export * from "./vipPublisher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports